<template>
  <tr data-test="organisationRow">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <td><slot name="selection" /></td>
      <template
        v-if="
          item.payable.productCodename == 'HORSE_SEASON_SPORT_LICENCE_BUNDLE'
        "
      >
        <td>
          {{
            $t(
              "people:ShoppingBasket.ShoppingBasketTab.HorseGroupLicence.text",
              "Horse group licence"
            )
          }}
          {{ item.payable.year }}

          <div v-if="item.paymentInProcess" class="secondary--text">
            {{
              $t(
                "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                "In process",
                "Label of the order table section"
              )
            }}
          </div>
        </td>
        <td>
          <AppOrganisationNameLink :organisation="item.organisation" />
          <slot name="notAllowedReasons" />
        </td>
        <td class="text-right"><slot name="price" /></td>
        <td><slot name="actions" /></td>
      </template>
      <template v-else>
        <td>
          {{ item.entityType }}

          <div v-if="item.paymentInProcess" class="secondary--text">
            {{
              $t(
                "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                "In process",
                "Label of the order table section"
              )
            }}
          </div>
        </td>
        <td>
          <AppOrganisationNameLink :organisation="item.organisation" />
        </td>
        <td class="text-right"><slot name="price" /></td>
        <td><slot name="actions" /></td>
      </template>
    </template>
    <template v-else>
      <td style="font-size: 12px" colspan="99">
        <v-row dense class="align-center">
          <v-col cols="1" class="mr-3">
            <slot name="selection" />
          </v-col>
          <v-col>
            <template
              v-if="
                item.payable.productCodename ==
                'HORSE_SEASON_SPORT_LICENCE_BUNDLE'
              "
            >
              <div>
                {{
                  $t(
                    "people:ShoppingBasket.ShoppingBasketTab.HorseGroupLicence.text",
                    "Horse group licence"
                  )
                }}
                {{ item.payable.year }}
              </div>
            </template>
            <template v-else>
              {{ item.entityType }}
            </template>
            <div v-if="item.payable.paymentInProcess" class="secondary--text">
              {{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                  "In process",
                  "Label of the order table section"
                )
              }}
            </div>
            <div>
              <AppOrganisationNameLink :organisation="item.organisation" />
            </div>
            <slot name="notAllowedReasons" />
          </v-col>
          <div>
            <slot name="price" />
          </div>
        </v-row>
        <div class="pa-1 mt-2 d-flex justify-end">
          <slot
            name="actions"
            :button-props="{
              small: false,
              xSmall: true
            }"
          />
        </div>
      </td>
    </template>
  </tr>
</template>
<script>
import AppOrganisationNameLink from "@/components/elements/AppNameLinks/AppOrganisationNameLink.vue";
export default {
  name: "OrganisationOrderDetails",
  components: {
    AppOrganisationNameLink
  },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>
